import { createTheme, virtualColor, type MantineThemeOverride } from '@mantine/core';
import { brandLight, brandDark, black } from './colors';

export const theme: MantineThemeOverride = createTheme({
    colors: {
        'brand-light': brandLight,
        'brand-dark': brandDark,
        brand: virtualColor({
            name: 'brand',
            light: 'brand-light',
            dark: 'brand-dark',
        }),
        black: black,
    },
    primaryColor: 'brand',
    components: {
        Modal: {
            defaultProps: {
                centered: true,
                lockScroll: true,
                withCloseButton: true,
                radius: 'md',
                shadow: 'xl',
            },
            styles: () => ({
                content: {
                    backgroundColor: 'var(--modal-bg)',
                    backdropFilter: 'blur(var(--modal-blur))',
                    border: '1px solid var(--modal-border)',
                },
                header: {
                    backgroundColor: 'transparent',
                },
            }),
        },
        LoadingOverlay: {
            defaultProps: {
                overlayProps: {
                    blur: 2,
                    backgroundOpacity: 0.1,
                },
            },
        },
        TextInput: {
            vars: () => ({
                root: {
                    '--input-bg': 'rgba(0, 0, 0, 0.03)',
                    '--input-bd': 'var(--modal-border)',
                }
            })
        },
        Select: {
            vars: () => ({
                root: {
                    '--input-bg': 'rgba(0, 0, 0, 0.03)',
                    '--input-bd': 'var(--modal-border)',
                },
            }),
            styles: () => ({
                dropdown: {
                    backgroundColor: 'var(--modal-bg)',
                    backdropFilter: 'blur(var(--modal-blur))',
                    border: '1px solid var(--modal-border)',
                }
            }),
        },
        PasswordInput: {
            vars: () => ({
                root: {
                    '--input-bg': 'rgba(0, 0, 0, 0.03)',
                    '--input-bd': 'var(--modal-border)',
                }
            }),
            styles: () => ({
                innerInput: {
                    backgroundColor: 'transparent !important',
                }
            }),
        },
        Textarea: {
            vars: () => ({
                root: {
                    '--input-bg': 'rgba(0, 0, 0, 0.03)',
                    '--input-bd': 'var(--modal-border)',
                }
            })
        },
        MultiSelect: {
            vars: () => ({
                root: {
                    '--input-bg': 'rgba(0, 0, 0, 0.03)',
                    '--input-bd': 'var(--modal-border)',
                }
            }),
            styles: () => ({
                dropdown: {
                    backgroundColor: 'var(--modal-bg)',
                    backdropFilter: 'blur(var(--modal-blur))',
                    border: '1px solid var(--modal-border)',
                }
            }),
        },
    },
    breakpoints: {
        xs: '36em',
        sm: '756px',
        md: '62em',
        lg: '75em',
        xl: '88em',
    },
});
